import React from 'react'
import { LogoutIcon } from '../icons'

export const Logout: React.FC = () => (
	<div className='logout'>
		<h3>Elon Musk</h3>
		<section className='button'>
			<LogoutIcon />
			Log Out
		</section>
	</div>
)
